
import { fetchWithLoader } from "./api";
// eslint-disable-next-line
export async function syncfav(data: any, userId: string) {
    if (!data || !userId) return null
    // eslint-disable-next-line
    const final = Object.values(data)?.map((item: any) => ({
        favourite_d_id: item.d_id,
        mobile_dt: item.mobile_dt
    }))

    const obj = {
        cc: "IN",
        lc: "eng",
        user_id: userId,
        a_id: "0",
        Data: {
            "favourite": final
        }
    }

    try {
        const response = await fetchWithLoader("drama_sync_screen.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(obj),
        });

        const result = await response.json();
        if (result.data.ErrorCode === 1) {
            const resObj = result.data.Data[0].favourite
            // eslint-disable-next-line
            .filter((item: any) =>
                item.d_id && item.d_id !== "0" && item.d_id !== 0 &&
                (item.d_title && item.d_title !== "" || item.d_name && item.d_name !== "") &&
                (item.d_image && item.d_image !== "" || item.d_logo && item.d_logo !== "")
            )// eslint-disable-next-line
            .map((item: any) => ({
                d_id: item.d_id,
                d_title: item.d_name,
                d_image: item.d_logo,
                total_ep: item.total_d_stream,
                mobile_dt: item.mobile_dt,
                d_name: item.d_name,
                total_d_stream: item.total_d_stream
            }));
            return resObj;
        } else {
            console.error("Sync failed:", result.ErrorMessage);
            return null;
        }
    } catch (error) {
        console.error("API call failed:", error);
        return null;
    }
}
